import apiClient from '@/services/rest-api/apiClient'
import apiClientV2 from '@/services/rest-api/apiClient'

const baseURL = process.env.VUE_APP_REST_API_VSMS

export const get = async (queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
  }

  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: '/box-type',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClient({
    baseURL,
    method: 'GET',
    url: `/box-type/${id}`,
  })

  return response?.data
}

export const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/box-type',
    params: params,
  })

  return response?.data
}

export const getV2 = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)
